import { take } from 'rxjs/operators';
import { BreakpointMinService } from 'src/app/@utils/breakpoint-min.service';

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavigationService } from '@core/services/navigation.service';
import { SettingsService } from '@core/services/settings.service';
import { SiteStateService } from '@core/services/site-state/site-state.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ProgressComponent } from '../progress/progress.component';
import { MainMenuComponent } from '../../navigation/desktop/main-menu/main-menu.component';
import { HeaderBasketLinkComponent } from './header-basket-link/header-basket-link.component';
import { MetaMenuComponent } from '../../navigation/desktop/meta-menu/meta-menu.component';
import { SearchContainerComponent } from '../../search/search-container/search-container/search-container.component';
import { RouterLink } from '@angular/router';
import { NgIf, AsyncPipe } from '@angular/common';
import { MobileMenuComponent } from '../../navigation/mobile/mobile-menu/mobile-menu.component';

@UntilDestroy()
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MobileMenuComponent, NgIf, RouterLink, SearchContainerComponent, MetaMenuComponent, HeaderBasketLinkComponent, MainMenuComponent, ProgressComponent, AsyncPipe]
})
export class HeaderComponent {
    constructor(
        public settingsService: SettingsService,
        public navigationService: NavigationService,
        public siteStateService: SiteStateService,
        public breakpointMinService: BreakpointMinService
    ) {}

    public onUpdateActiveIndexEvent(event: number | null): void {
        if (event !== null) {
            this.siteStateService.setState('backdrop', true);
            return;
        }

        this.siteStateService.state$.pipe(take(1), untilDestroyed(this)).subscribe(state => {
            if (state.backdrop) {
                this.siteStateService.setState('backdrop', false);
            }
        });
    }
}
